import {
    ChangeDetectionStrategy,
    Component,
    DoCheck,
    forwardRef,
    Injector,
    Input,
    OnChanges,
    ViewChild,
} from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NgControl,
} from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

// tslint:disable-next-line: no-conflicting-lifecycle
@Component({
    selector: 'app-duplicate-check',
    templateUrl: './duplicate-check.component.html',
    styleUrls: ['./duplicate-check.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DuplicateCheckComponent),
            multi: true,
        },
    ],
})
export class DuplicateCheckComponent
    implements OnChanges, ControlValueAccessor, DoCheck {
    @Input() documents: Document[];
    @Input() objectStore: string;

    value = false;

    onChanges = [];
    onTouched = [];
    touched = false;
    disabled = false;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    dataSource;
    displayedColumns: string[] = [
        'ContractDeletedDate',
        'Name',
        'ContractIdentifier',
        'Category',
    ];

    constructor(private injector: Injector) {}

    ngOnChanges(SimpleChanges): void {
        if (this.documents && this.documents.length > 0) {
            this.dataSource = new MatTableDataSource<Document>(this.documents);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }
    }

    paged(input: PageEvent) {
        this.dataSource.pageChange(input);
    }

    applySort(input: Sort) {
        this.dataSource.sortChanged(input);
    }

    applyFilter(filterValue: string) {
        this.dataSource.filterChange(filterValue.trim().toLowerCase());

        if (this.paginator) {
            this.paginator.firstPage();
        }
    }

    formChanged = (input: any) => {
        for (const change of this.onChanges) {
            change(this.value);
        }
    };

    writeValue(obj: boolean): void {
        this.value = obj;
    }

    ngDoCheck() {
        const ngControl = this.injector.get(NgControl);
        if (!ngControl.control) {
            return;
        }
        this.touched = ngControl.control.touched;
    }

    private setOnChangeCallback(fn: any) {
        this.onChanges.push(fn);
    }

    private setOnTouchCallback(fn: any) {
        this.onTouched.push(fn);
    }

    setIsDisabled(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // console.log('registerOnChange');
        this.setOnChangeCallback(fn);
    }
    registerOnTouched(fn: any): void {
        this.setOnTouchCallback(fn);
    }
    setDisabledState?(isDisabled: boolean): void {
        this.setIsDisabled(isDisabled);
    }
}
